import { EntityType } from '../../../@types/entityTypes';
import workspaceQuery from '../../queries/purchases/IntrastatGoodsReceiptLineWorkspaceQuery.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const IntrastatGoodsReceiptLine: EntityType = {
  type: 'GoodsReceiptLine',
  title: 'Intrastat Arrivals Report',
  workspaceUrl: '/Purchasing/IntrastatGoodReceiptLines/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'INTRASTAT_ARRIVALS_GOODS_RECEIPT_LINES',
  operations: ALLOW_VIEW,
};

export default IntrastatGoodsReceiptLine;
